module.exports = __webpack_public_path__ + "static/media/Veroreception.228e4acc.m4v";